import { render, staticRenderFns } from "./JobApplies.vue?vue&type=template&id=06af2e72&"
import script from "./JobApplies.vue?vue&type=script&lang=js&"
export * from "./JobApplies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports